import styled from "styled-components";
import theme from "../../theme/theme";

const Wrapper = styled.img`
  width: 80px;
  height: 32px;
  /* aspect-ratio: 1; */
  /* border-radius: 50%; */
  /* border: 1px solid ${(p) => p.borderColor || theme.colors.primary}; */
`;

const Avatar = ({ imgSrc, aWidth, borderColor }) => {
  return <Wrapper src={imgSrc}></Wrapper>;
};

export default Avatar;
